export enum FRAMES_CONSTANTS {
  SETTINGS = 'SETTINGS',
  NORMAL = 'NORMAL',
  MODE = 'mode',
  FRAME_ID = 'frameId',
}
